import {API} from "aws-amplify";

export const RateAlertAPI = {
    fetchRateAlerts: (staffId) => API.get('rate-alerts', '/list/' + staffId, {}),
    saveAlert: (payload) => API.post('rate-alerts', '/save', {body: payload}),
    updateAlert: (id, payload) => API.post('rate-alerts', `/update/${id}`, {body: payload}),
    fetchRateAlert: (id) => API.get('rate-alerts', `/get/${id}`, {}),
}